import Axios from '../baseApi';

export default {
  async fetchAll() {
    return await Axios.get(`/api-master-data/v1/slaughter-house/v1`)
  },
  async fetch(id) {
    return await Axios.get(`/api-master-data/v1/slaughter-house/${id}`)
  },
  async create(data) {
    return await Axios.post('/api-master-data/v1/slaughter-house', data);
  },
  async addOrUpdateTransport(id, data) {
    return await Axios.post(`/api-article/v1/slaughter-house-transport/${id}`, data);
  },
  async fetchTransport(slaughterHouseId) {
    return await Axios.get(`/api-article/v1/slaughter-house-transport/${slaughterHouseId}`);
  },
  fetchAvailableDeliveryPrograms(slaughterId) {
    return Axios.get(`/api-master-data/slaughter-available-delivery-programs/v1/${slaughterId}`);
  },
  addAvailableDeliveryPrograms(form) {
    return Axios.post(`/api-master-data/slaughter-available-delivery-programs/v1`, form);
  },
 deleteAvailableDeliveryPrograms(form) {
    return Axios.post(`/api-master-data/slaughter-available-delivery-programs/v1/delete`, form);
  }
}
